// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-alpine {
  --ag-font-family: Roboto, sans-serif;
  --ag-border-color: #f5f5f5;
  --ag-row-border-color: #f5f5f5;
  --ag-cell-horizontal-border: 1px solid #f5f5f5;
  --ag-selected-row-background-color: rgba(120, 182, 238, 0.3);
  --ag-row-hover-color: rgba(0, 120, 220, 0.1);
}
.ag-theme-alpine .ag-pinned-left-header {
  border-right: none;
}
.ag-theme-alpine .ag-horizontal-left-spacer {
  overflow-x: auto;
}
.ag-theme-alpine .ag-filter-apply-panel {
  display: flex;
  justify-content: space-around;
  height: 40px;
  border: none;
  background-color: #f9f9f9;
  box-shadow: inset 0 1px 0 0 #eaeaea;
}
.ag-theme-alpine .ag-filter-apply-panel .ag-simple-filter-body-wrapper {
  background-color: #ffffff;
}
.ag-theme-alpine .ag-filter-apply-panel .ag-filter-apply-panel-button {
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 14px;
  color: #0078dc;
  background-color: transparent;
  border: none;
}
.ag-theme-alpine .ag-filter-apply-panel .ag-filter-apply-panel-button:hover {
  color: #00426c;
  border: none;
  background-color: transparent;
}
.ag-theme-alpine .ag-filter-apply-panel .ag-filter-apply-panel-button:focus {
  box-shadow: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
